export const REGION = "eu-central-1";